
import { parseFragment, serialize } from 'parse5';


/**
 * Get animate style map
 * @param {*} config 
 * @returns 
 */
export const getAnimateStyleMap = (config) => {
    let { duration, enable, delay } = config;
    let style = {};
    if (enable !== false) {
        if (duration) {
            style['--animate-duration'] = `${duration}ms`;
        }
        if (delay) {
            style['--animate-delay'] = `${delay}ms`;
        }
    }
    return style;
}

/***
animationEffects = [
    { name: 'fade-in', selector: '.rt-fade-in', duration: 1500, enable: true },
    { name: 'shift-right', selector: '.rt-shift-right', duration: 1000, enable: true },
    { name: 'shift-left', selector: '.rt-shift-left', duration: 1000, enable: true },
    { name: 'shift-up', selector: '.rt-shift-up', duration: 1000, enable: true },
    { name: 'shift-down', selector: '.rt-shift-down', duration: 1000, enable: true },
    ]
 */


/**
 * Add animated to children of html string
 * @param {*} htmlString 
 * @param {*} animationEffects 
 * @returns 
 */
export const addAnimatedToChildren = (htmlString, animationEffects) => {
    if (!htmlString || !animationEffects?.length) {
        return htmlString;
    }

    const fragment = parseFragment(htmlString);
    
    // 构建 selector -> effect 映射
    const selectorMapConfig = {};
    for (const effect of animationEffects) {
        // 去掉 selector 的 . 前缀
        const selector = effect.selector.substring(1);
        selectorMapConfig[selector] = effect;
    }

    // 递归处理节点
    const processNode = (node) => {
        // 只处理元素节点（有 tagName 的节点）
        if (node.tagName && node.attrs) {
            const classAttr = node.attrs.find(attr => attr.name === 'class');
            if (classAttr) {
                const classList = classAttr.value.split(/\s+/);
                
                // 检查每个 class 是否匹配 animationEffects
                for (const className of classList) {
                    const effect = selectorMapConfig[className];
                    if (effect) {
                        // 添加动画名字到 class
                        classAttr.value = `${classAttr.value} ${effect.name}`;
                        
                        // 添加动画样式到 style
                        const styleMap = getAnimateStyleMap(effect);
                        const styleString = Object.entries(styleMap)
                            .map(([key, value]) => `${key}: ${value}`)
                            .join('; ');
                        
                        if (styleString) {
                            const styleAttr = node.attrs.find(attr => attr.name === 'style');
                            if (styleAttr) {
                                styleAttr.value = `${styleAttr.value}; ${styleString}`;
                            } else {
                                node.attrs.push({ name: 'style', value: styleString });
                            }
                        }
                    }
                }
            }
        }

        // 递归处理子节点
        if (node.childNodes) {
            for (const child of node.childNodes) {
                processNode(child);
            }
        }
    };

    processNode(fragment);
    return serialize(fragment);
}


// let res = addAnimatedToChildren("<div class='rt-fade-in'>Hello</div>", [
//     { name: 'fade-in', selector: '.rt-fade-in', duration: 1500, enable: true },
// ]);
// console.log('res====', res);